export const LOGISTICS_ORDERS_COLLECTION = 'logisticsOrders';
export const LOGISTICS_PROVIDERS_COLLECTION = 'logisticsProviders';
